import type { Contact } from '@/types/Contenu'

// Coordonnées officielles du CMP Lubumbashi — valeurs initiales, modifiables depuis /admin.
export const CONTACT_INITIAL: Contact = {
  adresse: '17 Avenue Nyangwe I, Quartier Lido, Commune de Lubumbashi Lubumbashi',
  lat: -11.6657936,
  lng: 27.4674237,
  telephone: '+243 816 681 958',
  whatsapp: '+243 816 681 958',
  secretariatHoraires: '09h00 - 17h00',
  secretariatJours: 'Du lundi au vendredi',
  facebook: 'https://www.facebook.com/CMPLubumbashi',
  youtube: 'https://www.youtube.com/@CMPLubumbashi',
  instagram: 'https://www.instagram.com/cmplubumbashi',
  tiktok: 'https://www.tiktok.com/@cmplubumbashi25',
  whatsappChaine: 'https://www.whatsapp.com/channel/0029VaoVVieIiRon8ltEFR15',
}
